import type {
  CashSummaryDto,
  ExpenseCategoryDto,
  InvoiceDto,
  PaymentDto,
} from "@grizzly/shared";
import { request } from "../http.js";

export const financeApi = {
  listExpenseCategories: () =>
    request<{ items: ExpenseCategoryDto[] }>("/expense-categories"),
  createExpenseCategory: (input: object) =>
    request<{ category: ExpenseCategoryDto }>("/expense-categories", {
      method: "POST",
      body: input,
    }),

  listInvoices: (status?: string) =>
    request<{ items: InvoiceDto[] }>(
      `/invoices${status ? `?status=${encodeURIComponent(status)}` : ""}`
    ),
  getInvoice: (id: string) =>
    request<{ invoice: InvoiceDto; payments: PaymentDto[] }>(`/invoices/${id}`),
  createInvoice: (input: object) =>
    request<{ invoice: InvoiceDto }>("/invoices", { method: "POST", body: input }),
  issueInvoice: (id: string, dueDate?: string) =>
    request<{ invoice: InvoiceDto }>(`/invoices/${id}/issue`, {
      method: "POST",
      body: { dueDate },
    }),
  voidInvoice: (id: string, reason: string) =>
    request<{ invoice: InvoiceDto }>(`/invoices/${id}/void`, {
      method: "POST",
      body: { reason },
    }),

  listPayments: () => request<{ items: PaymentDto[] }>("/payments"),
  recordPayment: (input: object) =>
    request<{ payment: PaymentDto }>("/payments", { method: "POST", body: input }),
  reversePayment: (id: string, reason: string) =>
    request<{ payment: PaymentDto }>(`/payments/${id}/reverse`, {
      method: "POST",
      body: { reason },
    }),

  recordExpense: (input: object) =>
    request<{ transaction: { id: string } }>("/expenses", {
      method: "POST",
      body: input,
    }),
  reverseCashTransaction: (id: string, reason: string) =>
    request<{ transaction: { id: string } }>(`/cash/${id}/reverse`, {
      method: "POST",
      body: { reason },
    }),
  listCash: () => request<CashSummaryDto>("/cash?limit=500"),
};
